/*
  Alpaca · carrito (cajón y página).
  1) Entrega: fecha real de llegada y costo de envío según la ciudad (la misma que se eligió en la ficha).
     El cálculo es el mismo que el del bloque "Alpaca · Envío" de la ficha: si se cambia uno, cambiar el otro.
  2) Totales: subtotal + envío según la ciudad = total.
  3) Regalo por prenda: marcar, escribir o cambiar el mensaje de la tarjeta, o quitarlo, sin salir del carrito.
  4) "Para sumar al regalo": agregar con un toque (en el carrito y en la ficha).
  Todo usa las rutas normales de Shopify y avisa a Horizon para que el carrito se vuelva a dibujar.
*/
import { CartLinesUpdateEvent } from '@shopify/events';

const CLAVE_CIUDAD = 'alpaca_ciudad';
const CLAVE_FERIADOS = 'alpaca_feriados';
/* Respaldo: la lista buena la guarda la ficha de producto (bloque Envío) al abrirse. */
const FERIADOS_RESPALDO = ['2026-10-09', '2026-11-02', '2026-11-03', '2026-12-25', '2027-01-01'];
const PRECIO = { quito: 499, resto: 550, mismo: 850 };
const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

/* ── Envío (copia del bloque de la ficha) ── */
function ahoraEc() {
  const d = new Date(Date.now() - 5 * 3600e3);
  return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), h: d.getUTCHours(), min: d.getUTCMinutes() };
}
const fecha = (y, m, d) => new Date(Date.UTC(y, m, d));
const iso = (f) => f.toISOString().slice(0, 10);
const mas = (f, n) => new Date(f.getTime() + n * 864e5);

function feriados() {
  try {
    const l = JSON.parse(localStorage.getItem(CLAVE_FERIADOS) || 'null');
    if (Array.isArray(l) && l.length) return l;
  } catch (e) {}
  return FERIADOS_RESPALDO;
}

/* Modo viaje sin reemplazo (12/10/2026): días sin Flash. Los guarda el bloque de envío (alpaca_sin_flash). */
function sinFlash(n) {
  if (window.AlpacaEnvio && window.AlpacaEnvio.sinFlash) return window.AlpacaEnvio.sinFlash(n);
  let l = [];
  try { l = JSON.parse(localStorage.getItem('alpaca_sin_flash') || '[]') || []; } catch (e) {}
  if (!n || !Array.isArray(l) || !l.length) return false;
  let f = fecha(n.y, n.m, n.d);
  if (n.h >= 21) f = new Date(f.getTime() + 864e5);
  return l.indexOf(iso(f)) >= 0;
}

/* Días de despacho: lunes a sábado, sin feriados (regla fija del 10/10/2026). */
function esDespacho(f, fer) { const w = f.getUTCDay(); return w >= 1 && w <= 6 && fer.indexOf(iso(f)) < 0; }

function nombreDia(f, hoy) {
  const dif = Math.round((f - hoy) / 864e5);
  const base = DIAS[f.getUTCDay()] + ' ' + f.getUTCDate();
  if (dif === 0) return 'hoy, ' + base;
  if (dif === 1) return 'mañana, ' + base;
  return 'el ' + base;
}

function calcular() {
  const fer = feriados();
  const n = ahoraEc();
  const hoy = fecha(n.y, n.m, n.d);
  /* Lo que se pide hoy sale el próximo día de despacho (la hora no importa) y llega al día siguiente,
     sin domingos ni feriados. Lunes → llega miércoles; viernes → lunes; sábado o domingo → martes. */
  let desp = mas(hoy, 1);
  while (!esDespacho(desp, fer)) desp = mas(desp, 1);
  let lleg = mas(desp, 1);
  while (lleg.getUTCDay() === 0 || fer.indexOf(iso(lleg)) >= 0) lleg = mas(lleg, 1);
  const texto = 'Llega ' + nombreDia(lleg, hoy) + '.';
  return { texto, n };
}

function quitar(t) {
  return t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z]+/g, ' ').trim();
}

const LUGARES = [
  ['Galápagos', 'galapagos', ['galapagos', 'islas galapagos']],
  ['Santa Cruz, Galápagos', 'galapagos', ['santa cruz', 'puerto ayora']],
  ['San Cristóbal, Galápagos', 'galapagos', ['san cristobal', 'puerto baquerizo', 'baquerizo moreno']],
  ['Isabela, Galápagos', 'galapagos', ['isabela', 'puerto villamil']],
  ['Quito', 'quito', ['quito', 'kito', 'uio']],
  ['Cumbayá', 'quito', ['cumbaya']], ['Tumbaco', 'quito', ['tumbaco']],
  ['Los Chillos', 'quito', ['chillos', 'los chillos', 'valle de los chillos']],
  ['Sangolquí', 'quito', ['sangolqui']], ['Conocoto', 'quito', ['conocoto']], ['Alangasí', 'quito', ['alangasi']],
  ['Calderón', 'quito', ['calderon']], ['Carapungo', 'quito', ['carapungo']], ['Pomasqui', 'quito', ['pomasqui']],
  ['Nayón', 'quito', ['nayon']], ['Puembo', 'quito', ['puembo']], ['Pifo', 'quito', ['pifo']],
  ['Tababela', 'quito', ['tababela']], ['Amaguaña', 'quito', ['amaguana']],
  ['Guayaquil', 'resto', ['guayaquil']], ['Cuenca', 'resto', ['cuenca']], ['Ambato', 'resto', ['ambato']],
  ['Manta', 'resto', ['manta']], ['Portoviejo', 'resto', ['portoviejo']], ['Machala', 'resto', ['machala']],
  ['Loja', 'resto', ['loja']], ['Ibarra', 'resto', ['ibarra']], ['Riobamba', 'resto', ['riobamba']],
  ['Esmeraldas', 'resto', ['esmeraldas']], ['Santo Domingo', 'resto', ['santo domingo']],
  ['Latacunga', 'resto', ['latacunga']], ['Otavalo', 'resto', ['otavalo']], ['Babahoyo', 'resto', ['babahoyo']],
  ['Quevedo', 'resto', ['quevedo']], ['Milagro', 'resto', ['milagro']], ['Tulcán', 'resto', ['tulcan']],
  ['Salinas', 'resto', ['salinas']], ['Santa Elena', 'resto', ['santa elena']], ['Durán', 'resto', ['duran']],
  ['Samborondón', 'resto', ['samborondon']], ['Azogues', 'resto', ['azogues']], ['Puyo', 'resto', ['puyo']],
  ['Tena', 'resto', ['tena']], ['Macas', 'resto', ['macas']], ['Lago Agrio', 'resto', ['lago agrio']],
  ['Coca', 'resto', ['coca']], ['Zamora', 'resto', ['zamora']],
];

function distancia(a, b) {
  const d = [];
  for (let i = 0; i <= a.length; i++) d[i] = [i];
  for (let j = 0; j <= b.length; j++) d[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
  }
  return d[a.length][b.length];
}
const tolerancia = (v) => (v === 'quito' ? 1 : v.length <= 5 ? 0 : v.length <= 7 ? 1 : 2);

function bonito(c) {
  const menores = ['de', 'del', 'la', 'las', 'los', 'y', 'el'];
  return c.trim().replace(/\s+/g, ' ').split(' ').map((p, i) => {
    const b = p.toLowerCase();
    return i > 0 && menores.indexOf(b) >= 0 ? b : b.charAt(0).toUpperCase() + b.slice(1);
  }).join(' ');
}

function buscar(c) {
  const t = quitar(c);
  if (!t) return c.trim() ? { tipo: 'resto', nombre: c.trim().slice(0, 40) } : null;
  const w = t.split(' ');
  for (let pase = 0; pase < 2; pase++) {
    for (const L of LUGARES) {
      for (const v of L[2]) {
        const k = v.split(' ').length;
        const tol = pase === 0 ? 0 : tolerancia(v);
        if (pase === 1 && tol === 0) continue;
        for (let i = 0; i + k <= w.length; i++) {
          const g = w.slice(i, i + k).join(' ');
          if (Math.abs(g.length - v.length) > tol) continue;
          if (distancia(g, v) <= tol) return { tipo: L[1], nombre: k === w.length ? L[0] : bonito(c) };
        }
      }
    }
  }
  return { tipo: 'resto', nombre: bonito(c) };
}

function lugarGuardado() {
  let c = '';
  try { c = localStorage.getItem(CLAVE_CIUDAD) || ''; } catch (e) {}
  return c ? buscar(c) || { tipo: 'resto', nombre: c } : null;
}

const dinero = (cents) => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/* ── Códigos que el carrito no puede calcular ──
   Un código de envío gratis (o cualquier descuento sobre el envío) queda guardado en el carrito, pero Shopify no lo
   lista en el carrito (Liquid): solo se aplica al pagar, con la dirección. El resumen lleva en data-codigos los códigos
   que sí muestra; si /cart.js trae otro código aplicable, el envío pasa a «lo ves al pagar» y el total va sin envío.
   No cambia nada del pago: solo lo que se muestra. */
let codigosAplicados = null;
function guardarCodigos(lista) {
  codigosAplicados = (Array.isArray(lista) ? lista : [])
    .filter((d) => d && d.applicable && d.code)
    .map((d) => String(d.code).trim().toLowerCase());
}
function codigoSinCalcular(caja) {
  if (!codigosAplicados || !codigosAplicados.length) return false;
  const vistos = (caja.getAttribute('data-codigos') || '').toLowerCase().split('|').map((c) => c.trim()).filter(Boolean);
  return codigosAplicados.some((c) => vistos.indexOf(c) < 0);
}
async function releerCodigos() {
  try {
    const c = await leerCarrito();
    guardarCodigos(c && c.discount_codes);
    pintar();
  } catch (e) {}
}

/* ── Pintar entrega y totales ── */
/* Solo escribe si cambió: así el vigía de cambios no entra en bucle. */
function poner(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

let ultimoTotal = '';
let ultimaNota = '';

function pintar() {
  const lugar = lugarGuardado();
  const tipo = lugar ? lugar.tipo : '';
  const r = calcular();
  const envioCiudad = tipo === 'quito' ? PRECIO.quito : PRECIO.resto;
  const primeraCaja = document.querySelector('[data-alp-totales]');
  const inciertoEntrega = !!primeraCaja && codigoSinCalcular(primeraCaja);

  document.querySelectorAll('[data-alp-entrega]').forEach((caja) => {
    const fechaEl = caja.querySelector('[data-alp-ce-fecha]');
    const dondeEl = caja.querySelector('[data-alp-ce-donde]');
    const extraEl = caja.querySelector('[data-alp-ce-extra]');
    const boton = caja.querySelector('[data-alp-ce-cambiar]');
    if (tipo === 'galapagos') {
      poner(fechaEl, 'A ' + lugar.nombre + ' tarda unos días más.');
      poner(dondeEl, 'Envío por confirmar: te escribimos por WhatsApp');
    } else if (inciertoEntrega) {
      poner(fechaEl, r.texto);
      poner(dondeEl, 'Envío' + (lugar ? ' a ' + lugar.nombre : '') + ': lo ves al pagar, con tu código');
    } else {
      poner(fechaEl, r.texto);
      poner(dondeEl, 'Envío ' + dinero(envioCiudad) + (lugar ? ' a ' + lugar.nombre : ' a todo el Ecuador'));
    }
    if (boton) poner(boton, lugar ? 'Cambiar ciudad' : 'Ver para tu ciudad');
    if (extraEl) {
      const hoyTxt = tipo === 'quito' && !sinFlash(r.n)
        ? (r.n.h < 21 ? '¿Lo necesitas hoy? Al pagar elige «Alpaca Flash» (' + dinero(PRECIO.mismo) + '), antes de las 9 p. m.' : '')
        : '';
      poner(extraEl, hoyTxt);
      if (extraEl.hidden !== !hoyTxt) extraEl.hidden = !hoyTxt;
    }
  });

  document.querySelectorAll('[data-alp-totales]').forEach((caja) => {
    const sub = Number(caja.getAttribute('data-subtotal')) || 0;
    const conEnvio = caja.getAttribute('data-envio') !== 'no';
    const envioEl = caja.querySelector('[data-alp-tot-envio]');
    const envioTxt = caja.querySelector('[data-alp-tot-envio-txt]');
    const totalEl = caja.querySelector('[data-alp-tot-total]');
    const totalLbl = caja.querySelector('[data-alp-tot-total-txt]');
    const notaEl = caja.querySelector('[data-alp-tot-nota]');
    /* Con un código que el carrito no puede calcular (envío gratis…), el envío no se suma como seguro. */
    const incierto = conEnvio && codigoSinCalcular(caja);
    poner(totalLbl, incierto ? 'Total sin envío' : 'Total');
    let totalTxt;
    if (!conEnvio) {
      totalTxt = dinero(sub);
      poner(envioEl, dinero(0));
      poner(notaEl, '');
    } else if (incierto) {
      poner(envioTxt, 'Envío');
      poner(envioEl, 'lo ves al pagar');
      totalTxt = dinero(sub);
      poner(notaEl, 'Tu código se aplica al envío al pagar, con la dirección.');
    } else if (tipo === 'galapagos') {
      poner(envioEl, 'por confirmar');
      poner(envioTxt, 'Envío a Galápagos');
      totalTxt = dinero(sub) + ' + envío';
      poner(notaEl, 'Te confirmamos el costo del envío por WhatsApp.');
    } else {
      poner(envioEl, dinero(envioCiudad));
      poner(envioTxt, lugar ? 'Envío a ' + lugar.nombre : 'Envío a domicilio');
      totalTxt = dinero(sub + envioCiudad);
      /* Carrito limpio (10/10, Nico): sin nota en el caso normal; la franja de entrega ya dice el envío. */
      poner(notaEl, '');
    }
    ultimoTotal = totalTxt;
    ultimaNota = !conEnvio ? '' : incierto ? 'sin envío' : tipo === 'galapagos' ? 'más envío por confirmar' : 'con envío';
    if (totalEl) {
      const bdi = totalEl.querySelector('bdi');
      if (bdi) poner(bdi, totalTxt); else poner(totalEl, totalTxt);
      if (totalEl.getAttribute('value') !== totalTxt) totalEl.setAttribute('value', totalTxt);
    }
  });

  /* Barra chica de abajo (total + botón): mismo total */
  if (ultimoTotal) {
    document.querySelectorAll('[data-alp-mini-total]').forEach((el) => poner(el, ultimoTotal));
    document.querySelectorAll('[data-alp-mini-nota]').forEach((el) => poner(el, ultimaNota));
  }
  vigilarMinis();
  aplicarMinis();
  restaurarBorradores();
}

/* La barra chica se esconde cuando el botón del resumen completo ya está a la vista, y mientras se escribe.
   El estado vive aquí (no solo en la página), porque Horizon borra los atributos al redibujar. */
const ocultoEn = new Map();
let escribiendo = false;
function aplicarMinis() {
  let enPagina = false;
  document.querySelectorAll('[data-alp-mini]').forEach((m) => {
    const oculto = !!ocultoEn.get(m.closest('#cart-drawer') || document);
    if (m.hasAttribute('data-oculto') !== oculto) m.toggleAttribute('data-oculto', oculto);
    if (m.hasAttribute('data-escribiendo') !== escribiendo) m.toggleAttribute('data-escribiendo', escribiendo);
    if (!oculto && !escribiendo && m.classList.contains('alp-cm--pagina')) enPagina = true;
  });
  const html = document.documentElement;
  if (html.classList.contains('alp-con-mini') !== enPagina) html.classList.toggle('alp-con-mini', enPagina);
}
const minisVistos = new WeakMap();
function vigilarMinis() {
  if (!('IntersectionObserver' in window)) return;
  document.querySelectorAll('[data-alp-mini]').forEach((mini) => {
    const cajon = mini.closest('#cart-drawer');
    const raizEl = cajon ? cajon.querySelector('.cart-drawer__content') : null;
    const zona = (cajon || document).querySelector('.cart__checkout-button');
    if (!zona || minisVistos.has(zona)) return;
    const io = new IntersectionObserver((es) => {
      const visible = es[es.length - 1].isIntersecting;
      if (!zona.isConnected) { io.disconnect(); return; }
      ocultoEn.set(zona.closest('#cart-drawer') || document, visible);
      aplicarMinis();
    }, { root: raizEl, threshold: 0.6, rootMargin: '0px 0px -80px 0px' });
    io.observe(zona);
    minisVistos.set(zona, io);
  });
}

/* Mientras se escribe (tarjeta, ciudad, código) la barra chica se va, para que el teclado no la suba encima. */
function teclado(ev, activo) {
  const t = ev.target;
  if (!(t instanceof HTMLTextAreaElement || t instanceof HTMLInputElement)) return;
  if (!t.closest('#cart-drawer, cart-items-component')) return;
  escribiendo = activo;
  aplicarMinis();
}
document.addEventListener('focusin', (ev) => teclado(ev, true));
document.addEventListener('focusout', (ev) => teclado(ev, false));

/* ── Avisar a Horizon que el carrito cambió, para que lo vuelva a dibujar ── */
function seccionesCarrito() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((e) => e.dataset && e.dataset.sectionId)
    .filter(Boolean);
}

/* Con señal mala un pedido puede quedarse colgado; mientras tanto el carrito está bloqueado.
   A los 15 s se corta y se avisa, para que nunca quede trabado. */
async function conTiempo(url, opciones, leer) {
  const ctl = typeof AbortController === 'function' ? new AbortController() : null;
  const reloj = ctl ? setTimeout(() => ctl.abort(), 15000) : 0;
  try {
    const r = await fetch(url, Object.assign({}, opciones, ctl ? { signal: ctl.signal } : {}));
    return await leer(r);
  } finally { clearTimeout(reloj); }
}
async function leerCarrito() {
  return conTiempo(raiz + 'cart.js', { headers: { Accept: 'application/json' } }, (r) => r.json());
}

/* Avisos para lectores de pantalla. Con el cajón abierto en el celular (modal) solo se oye lo que está
   dentro del cajón: por eso hay un aviso adentro (cart-drawer.liquid) y otro en la página. */
function zonaAvisos() {
  const dentro = document.querySelector('dialog[open] [data-alp-anuncio]');
  if (dentro) return dentro;
  let el = document.getElementById('alp-anuncio-carrito');
  if (!el) {
    el = document.createElement('p');
    el.id = 'alp-anuncio-carrito';
    el.className = 'visually-hidden';
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
  }
  return el;
}
zonaAvisos();
function anunciar(txt) {
  const el = zonaAvisos();
  el.textContent = '';
  setTimeout(() => { el.textContent = txt; }, 80);
}

/* Un cambio a la vez, y nunca encima de un cambio de cantidad de Horizon: mientras tanto el carrito
   queda bloqueado (Horizon lo muestra atenuado). */
let cola = Promise.resolve();
let trabajando = 0;
function bloquear(si) {
  document.querySelectorAll('cart-items-component').forEach((c) => c.classList.toggle('cart-items-disabled', si));
}
function enCola(tarea) {
  trabajando++;
  const correr = async () => {
    const CI = customElements.get('cart-items-component');
    const pendientes = CI && CI.pendingQuantityUpdates;
    if (pendientes && typeof pendientes[Symbol.iterator] === 'function') await Promise.allSettled(Array.from(pendientes));
    bloquear(true);
    try { return await tarea(); } finally { bloquear(false); }
  };
  const siguiente = cola.then(correr, correr);
  cola = siguiente.catch(() => {}).finally(() => { trabajando--; });
  return siguiente;
}

function cambiarCarrito(accion, lineas, hacer, origen, sinAbrir) {
  return enCola(async () => {
    const diferido = CartLinesUpdateEvent.createPromise();
    /* Sumar desde la ficha no abre el cajón: se apaga "auto-open" solo para este aviso. */
    const cd = sinAbrir ? document.querySelector('cart-drawer-component[auto-open]') : null;
    if (cd) cd.removeAttribute('auto-open');
    (origen && origen.isConnected ? origen : document).dispatchEvent(
      new CartLinesUpdateEvent({ action: accion, context: 'cart', lines: lineas, promise: diferido.promise })
    );
    if (cd) cd.setAttribute('auto-open', '');
    try {
      const respuesta = await hacer(seccionesCarrito().join(','));
      const carrito = respuesta && Array.isArray(respuesta.items) && typeof respuesta.item_count === 'number' ? respuesta : await leerCarrito();
      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(carrito),
        detail: { items: carrito.items, source: 'alpaca-carrito', itemCount: carrito.item_count, sections: respuesta && respuesta.sections, didError: false },
      });
      return carrito;
    } catch (error) {
      /* Si se cortó por tiempo, el cambio pudo hacerse igual: se lee el carrito real y se redibuja con eso,
         para no mostrar algo viejo ni sumar dos veces al reintentar. */
      if (error && error.name === 'AbortError') {
        let real = null;
        try { real = await leerCarrito(); } catch (e2) { real = null; }
        if (real && Array.isArray(real.items)) {
          diferido.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(real),
            detail: { items: real.items, source: 'alpaca-carrito', itemCount: real.item_count, didError: false },
          });
          error.carrito = real;
          throw error;
        }
      }
      /* Cada cambio es un solo pedido: si falla, no cambió nada y no hace falta redibujar
         (así no se borra lo que la persona escribió ni el aviso de error). */
      diferido.reject(error);
      throw error;
    }
  });
}

async function pedir(ruta, cuerpo) {
  const { r, j } = await conTiempo(raiz + ruta, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(cuerpo),
  }, async (r) => ({ r, j: await r.json().catch(() => ({})) }));
  if (!r.ok || j.status) {
    const e = new Error(j.description || j.message || 'carrito');
    e.estado = r.status;
    e.detalle = j.description || '';
    throw e;
  }
  return j;
}

/* ¿La persona usa teclado o dedo/mouse? El foco solo se mueve solo para quien usa teclado
   (con dedo o mouse, un recuadro que aparece de la nada se ve como un error). */
let usoTeclado = false;
document.addEventListener('keydown', (e) => { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ' || e.key === 'Escape' || e.key.indexOf('Arrow') === 0) usoTeclado = true; }, true);
document.addEventListener('pointerdown', () => { usoTeclado = false; }, true);

/* Lleva el foco a un elemento que todavía no existe (el carrito se está redibujando): lo busca un rato. */
function focoPerdido() {
  const a = document.activeElement;
  return !a || a === document.body || !a.isConnected;
}
/* Con mouse o dedo no se pinta el anillo: se suelta primero el foco anterior (si era un campo de texto,
   el navegador heredaría el anillo) y se pide sin anillo. */
function darFoco(el, desplazar) {
  if (!usoTeclado) { const a = document.activeElement; if (a && a !== document.body && a.blur) a.blur(); }
  try { el.focus({ preventScroll: !desplazar, focusVisible: usoTeclado }); } catch (e) { el.focus(); }
}
function enfocar(buscarEl, t0 = performance.now()) {
  const el = buscarEl();
  if (el && el.isConnected) { if (usoTeclado || focoPerdido()) darFoco(el, usoTeclado); return; }
  if (performance.now() - t0 < 2500) requestAnimationFrame(() => enfocar(buscarEl, t0));
}

/* ── Regalo por prenda ── */
const REGALO = 'Para regalo';
const MENSAJE = 'Mensaje de la tarjeta';

/* Muestra un elemento: dentro del cajón mueve solo la lista (sin tocar la página de atrás) y deja libre
   el espacio de la barra chica; fuera del cajón, la página. */
function mostrarEn(el) {
  if (!el || !el.isConnected) return;
  const sc = el.closest('#cart-drawer .cart-drawer__content');
  if (!sc) { el.scrollIntoView({ block: 'nearest' }); return; }
  const a = sc.getBoundingClientRect();
  const b = el.getBoundingClientRect();
  const libre = a.bottom - 88;
  if (b.top < a.top + 8) sc.scrollTop += b.top - a.top - 12;
  else if (b.bottom > libre) sc.scrollTop += Math.min(b.bottom - libre + 12, b.top - a.top - 12);
}

function contar(t) {
  const c = t.closest('[data-alp-cr]').querySelector('[data-alp-cr-cuenta]');
  if (c) c.textContent = t.value.length + ' de ' + t.maxLength + ' letras';
}

function abrirRegalo(caja, abrir) {
  const form = caja.querySelector('[data-alp-cr-form]');
  const boton = caja.querySelector('[data-alp-cr-editar]');
  if (!form) return;
  form.hidden = !abrir;
  caja.toggleAttribute('data-editando', abrir);
  if (boton) boton.setAttribute('aria-expanded', String(abrir));
  if (abrir) {
    const t = form.querySelector('textarea');
    if (t) { t.setAttribute('data-original', t.value); t.focus({ preventScroll: true }); t.setSelectionRange(t.value.length, t.value.length); contar(t); }
    mostrarEn(form);
  } else if (boton) {
    const t = form.querySelector('textarea');
    if (t && t.hasAttribute('data-original')) t.value = t.getAttribute('data-original');
    borradores.delete(caja.getAttribute('data-key'));
    const aviso = caja.querySelector('[data-alp-cr-aviso]');
    if (aviso) aviso.textContent = '';
    if (usoTeclado || form.contains(document.activeElement) || focoPerdido()) darFoco(boton, usoTeclado);
  }
}

/* Tarjetas a medio escribir: si Horizon redibuja el carrito (por ejemplo, al cambiar la cantidad de otra
   prenda), se vuelven a abrir con lo escrito. */
const borradores = new Map();
function restaurarBorradores() {
  borradores.forEach((txt, key) => {
    const c = document.querySelector('[data-alp-cr][data-key="' + CSS.escape(key) + '"]');
    if (!c) { borradores.delete(key); return; }
    const form = c.querySelector('[data-alp-cr-form]');
    const t = c.querySelector('textarea');
    if (!form || !t) return;
    if (!c.hasAttribute('data-editando')) {
      form.hidden = false;
      c.setAttribute('data-editando', '');
      const b = c.querySelector('[data-alp-cr-editar]');
      if (b) b.setAttribute('aria-expanded', 'true');
      if (!t.hasAttribute('data-original')) t.setAttribute('data-original', t.defaultValue);
    }
    if (t.value !== txt) { t.value = txt; contar(t); }
  });
}

/* Lo que se escribió y todavía no se guardó (para no perderlo al ir a pagar). */
function regaloSinGuardar() {
  return Array.from(document.querySelectorAll('[data-alp-cr][data-editando]')).find((caja) => {
    const t = caja.querySelector('textarea');
    return t && t.value.trim() !== (t.getAttribute('data-original') || '').trim();
  }) || null;
}

async function guardarRegalo(caja, quitarRegalo) {
  const clave = caja.getAttribute('data-key');
  const t = caja.querySelector('textarea');
  const msg = t ? t.value.trim().slice(0, 200) : '';
  const aviso = caja.querySelector('[data-alp-cr-aviso]');
  const botones = caja.querySelectorAll('button');
  botones.forEach((b) => (b.disabled = true));
  caja.setAttribute('aria-busy', 'true');
  if (aviso) aviso.textContent = '';
  let posicion = -1;

  try {
    const carrito = await cambiarCarrito('update', [{ id: clave, quantity: Number(caja.getAttribute('data-cantidad')) || 1 }], async (secciones) => {
      /* Cantidad y datos se leen del carrito en este momento (no de la pantalla, que puede estar atrasada). */
      const ahora = await leerCarrito();
      posicion = ahora.items.findIndex((i) => i.key === clave);
      const linea = ahora.items[posicion];
      if (!linea) throw new Error('linea');
      const nuevas = {};
      Object.keys(linea.properties || {}).forEach((k) => {
        const v = linea.properties[k];
        if (k !== REGALO && k !== MENSAJE && k !== '_regalo' && typeof v === 'string' && v !== '') nuevas[k] = v;
      });
      if (!quitarRegalo) {
        nuevas[REGALO] = 'Sí';
        if (msg) nuevas[MENSAJE] = msg;
      }
      /* Shopify no deja dejar una prenda sin datos: si no queda ninguno, va uno escondido (no se ve al pagar). */
      if (!Object.keys(nuevas).length) nuevas._regalo = 'no';
      return pedir('cart/change.js', { id: clave, quantity: linea.quantity, properties: nuevas, sections: secciones, sections_url: location.pathname });
    });
    borradores.delete(clave);
    anunciar(quitarRegalo ? 'Listo: ya no va para regalo.' : 'Tarjeta guardada.');
    const nueva = carrito.items[posicion] && carrito.items[posicion].key;
    if (nueva) enfocar(() => document.querySelector('[data-alp-cr][data-key="' + CSS.escape(nueva) + '"] [data-alp-cr-editar]'));
    return true;
  } catch (e) {
    botones.forEach((b) => (b.disabled = false));
    caja.removeAttribute('aria-busy');
    if (aviso) aviso.textContent = 'No pudimos guardarlo. Intenta de nuevo o escríbenos por WhatsApp.';
    return false;
  }
}

/* ── Sumar una prenda con un toque ── */
function pulsoCarrito() {
  document.querySelectorAll('.header-actions__cart-icon').forEach((el) => {
    el.classList.remove('alp-pulso');
    void el.offsetWidth;
    el.classList.add('alp-pulso');
  });
}

async function sumar(boton) {
  const variante = Number(boton.getAttribute('data-alp-sumar'));
  if (!variante || boton.getAttribute('aria-busy') === 'true' || boton.hasAttribute('data-sumado')) return;
  const texto = boton.querySelector('[data-alp-sumar-texto]') || boton;
  const antes = texto.textContent;
  const nombre = boton.getAttribute('data-nombre') || 'La prenda';
  /* Fuera del carrito el botón queda en «En tu carrito ✓».
     - «Arma el regalo completo» (ficha): se suma sin abrir el cajón, para armar el regalo de corrido (decisión del dueño).
     - Tarjeta de prenda (.alp-t: colecciones, búsqueda, rieles de la portada): se abre el cajón como con el botón
       principal de la ficha, con su «Agregaste … ✓» (menos en la página /cart, donde ya se ve el carrito).
     En el carrito, se ve al instante. */
  const enFicha = !boton.closest('#cart-drawer, cart-items-component');
  const enTarjeta = enFicha && !!boton.closest('.alp-t') && !document.querySelector('.cart-page');
  boton.setAttribute('aria-busy', 'true');
  try {
    const carrito = await cambiarCarrito('add', [{ merchandiseId: String(variante), quantity: 1 }], (secciones) =>
      pedir('cart/add.js', { items: [{ id: variante, quantity: 1 }], sections: secciones, sections_url: location.pathname })
    , boton, enFicha && !enTarjeta);
    anunciar(nombre + ' se agregó al carrito. Total de prendas: ' + carrito.item_count + '.');
    pulsoCarrito();
    if (enFicha) {
      texto.textContent = 'En tu carrito ✓';
      boton.setAttribute('data-sumado', '');
      boton.setAttribute('aria-disabled', 'true');
      boton.removeAttribute('aria-busy');
      if (enTarjeta) abrirConAviso(variante);
    } else {
      const linea = carrito.items.find((i) => i.variant_id === variante);
      if (linea) enfocar(() => { const fila = document.getElementById('CartItem-' + linea.key); return fila && fila.querySelector('.cart-items__title'); });
      setTimeout(() => {
        if (boton.closest('#cart-drawer') || document.querySelector('#cart-drawer dialog[open]')) { marcarAgregado([{ id: variante }]); return; }
        const caja = document.querySelector('.cart-page [data-alp-cr][data-variante="' + variante + '"]');
        const fila = caja && caja.closest('tr');
        if (fila) { cerrarDeshacer(); fila.classList.remove('alp-nueva'); void fila.offsetWidth; fila.classList.add('alp-nueva'); }
      }, 160);
    }
  } catch (e) {
    /* Se cortó por tiempo pero sí quedó en el carrito: es un éxito. */
    if (e && e.carrito && e.carrito.items.some((i) => i.variant_id === variante)) {
      anunciar(nombre + ' se agregó al carrito.');
      pulsoCarrito();
      if (enFicha) {
        texto.textContent = 'En tu carrito ✓';
        boton.setAttribute('data-sumado', '');
        boton.setAttribute('aria-disabled', 'true');
        if (enTarjeta) abrirConAviso(variante);
      }
      boton.removeAttribute('aria-busy');
      return;
    }
    texto.textContent = e && e.estado === 422 ? 'Ya no hay más' : 'No se pudo agregar';
    anunciar(e && e.estado === 422 ? 'No hay más unidades de ' + nombre + '.' : 'No se pudo agregar. Intenta de nuevo.');
    setTimeout(() => { texto.textContent = antes; boton.removeAttribute('aria-busy'); }, 2600);
  }
}

/* Tras sumar desde una tarjeta: abre el cajón (si Horizon no lo abrió solo) y, cuando ya muestra la prenda,
   pone «Agregaste … ✓» arriba, igual que el botón principal de la ficha. */
function abrirConAviso(variante) {
  const cajon = document.getElementById('cart-drawer');
  if (!cajon) return;
  setTimeout(() => {
    if (!document.querySelector('#cart-drawer dialog[open]') && typeof cajon.open === 'function') cajon.open();
    const t0 = performance.now();
    const buscar = () => {
      const abierto = document.querySelector('#cart-drawer dialog[open]');
      const caja = abierto && document.querySelector('#cart-drawer [data-alp-cr][data-variante="' + variante + '"]');
      if (caja) { marcarAgregado([{ id: variante }]); return; }
      if (performance.now() - t0 < 3000) setTimeout(buscar, 100);
    };
    buscar();
  }, 160);
}

/* Si la prenda se quitó del carrito, su botón de la ficha vuelve a decir "Agregar". */
async function revisarSumados() {
  const botones = document.querySelectorAll('[data-alp-sumar][data-sumado]');
  if (!botones.length) return;
  const c = await leerCarrito();
  const hay = new Set(c.items.map((i) => i.variant_id));
  botones.forEach((b) => {
    if (hay.has(Number(b.getAttribute('data-alp-sumar')))) return;
    b.removeAttribute('data-sumado');
    b.removeAttribute('aria-disabled');
    const t = b.querySelector('[data-alp-sumar-texto]');
    if (t) t.textContent = 'Agregar';
  });
}

/* ── Quitar con "Deshacer" ── */
function leerProps(txt) {
  try {
    const p = JSON.parse(txt || 'null');
    if (Array.isArray(p)) { const o = {}; p.forEach((x) => { if (Array.isArray(x) && x.length === 2) o[x[0]] = x[1]; }); return o; }
    return p && typeof p === 'object' ? p : {};
  } catch (e) { return {}; }
}

/* Prendas quitadas en esta visita: su sugerencia se esconde y aparece la de reserva. */
const CLAVE_QUITADOS = 'alpaca_quitados';
function leerQuitados() {
  try { const l = JSON.parse(sessionStorage.getItem(CLAVE_QUITADOS) || '[]'); return Array.isArray(l) ? l.filter((x) => Number.isFinite(x)) : []; } catch (e) { return []; }
}
function pintarQuitados(lista) {
  let s = document.getElementById('alp-quitados-css');
  if (!s) { s = document.createElement('style'); s.id = 'alp-quitados-css'; document.head.appendChild(s); }
  s.textContent = lista.map((id) => {
    const m = '.alp-cs:has([data-alp-sumar="' + id + '"])';
    return m + '{display:none!important}' + m + ' + .alp-cs--reserva{display:block}';
  }).join('\n');
}
function marcarQuitado(id, quitado) {
  if (!id) return;
  const l = leerQuitados().filter((x) => x !== id);
  if (quitado) l.push(id);
  try { sessionStorage.setItem(CLAVE_QUITADOS, JSON.stringify(l.slice(-20))); } catch (e) {}
  pintarQuitados(l);
}
pintarQuitados(leerQuitados());

let avisoQuitar = null;
let relojQuitar = 0;
let restoQuitar = null;
let reanudarQuitar = null;
let ioQuitar = null;
/* Si la persona se va a WhatsApp o a otra app, el reloj se detiene y vuelve a contar al regresar. */
document.addEventListener('visibilitychange', () => {
  if (!avisoQuitar) return;
  if (document.hidden) clearTimeout(relojQuitar);
  else if (reanudarQuitar) reanudarQuitar();
});

/* suave = se acabó el tiempo: se desvanece pero deja su lugar (invisible) hasta que se cierre el cajón o
   pase otra cosa en el carrito, para que nada se mueva justo cuando la persona va a tocar algo.
   Sin suave (otra acción, cerrar el cajón): se quita del todo. */
function esNuestro(n) { return !!n && (n.id === 'alp-quitado-fila' || n.id === 'alp-quitado-linea'); }
function cerrarDeshacer(suave) {
  clearTimeout(relojQuitar);
  reanudarQuitar = null;
  if (ioQuitar) { ioQuitar.disconnect(); ioQuitar = null; }
  if (!suave && restoQuitar) { if (esNuestro(restoQuitar)) restoQuitar.remove(); restoQuitar = null; }
  if (!avisoQuitar) return;
  const caja = avisoQuitar;
  avisoQuitar = null;
  if (!esNuestro(caja) || !caja.isConnected) return;
  if (!suave) { caja.remove(); return; }
  if (caja.contains(document.activeElement)) document.activeElement.blur();
  caja.inert = true;
  caja.classList.add('alp-quitado--saliendo');
  const lento = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  setTimeout(() => caja.classList.add('alp-quitado--oculto'), lento ? 300 : 0);
  restoQuitar = caja;
}

function mostrarDeshacer(dato, enCajon) {
  cerrarDeshacer();
  /* Una línea discreta, no una caja flotante. En el cajón va bajo el título (siempre a la vista);
     en la página, en el lugar de la prenda quitada, donde la persona está mirando. */
  const cont = enCajon ? document.querySelector('#cart-drawer .theme-drawer__header') : document.querySelector('.cart-page__title');
  const cuerpo = enCajon ? null : document.querySelector('.cart-page .cart-items__table tbody');
  if (!cont && !cuerpo) return;
  const previo = document.querySelector('.alp-agregaste');
  if (previo && (enCajon || !previo.closest('#cart-drawer'))) previo.remove();
  const caja = document.createElement('p');
  caja.id = 'alp-quitado-linea';
  caja.className = 'alp-quitado';
  const p = document.createElement('span');
  p.textContent = 'Quitaste ' + dato.nombre + '.';
  const b = document.createElement('button');
  b.type = 'button';
  b.textContent = 'Deshacer';
  b.addEventListener('click', async () => {
    b.disabled = true;
    try {
      const props = {};
      Object.keys(dato.props).forEach((k) => { const v = dato.props[k]; if (typeof v === 'string' && v !== '') props[k] = v; });
      const item = { id: dato.variante, quantity: dato.cantidad };
      if (Object.keys(props).length) item.properties = props;
      const carrito = await cambiarCarrito('add', [{ merchandiseId: String(dato.variante), quantity: dato.cantidad }], (secciones) =>
        pedir('cart/add.js', { items: [item], sections: secciones, sections_url: location.pathname })
      , null, true);
      cerrarDeshacer();
      marcarQuitado(dato.variante, false);
      anunciar(dato.nombre + ' volvió a tu carrito.');
      const linea = carrito.items.find((i) => i.variant_id === dato.variante);
      if (linea) enfocar(() => { const fila = document.getElementById('CartItem-' + linea.key); return fila && fila.querySelector('.cart-items__title'); });
    } catch (e) {
      p.textContent = 'No pudimos volver a agregarlo.';
      b.remove();
    }
  });
  caja.append(p, ' ', b);
  let envoltura = caja;
  if (cuerpo && cuerpo.querySelector('tr')) {
    caja.removeAttribute('id');
    envoltura = document.createElement('tr');
    envoltura.id = 'alp-quitado-fila';
    envoltura.className = 'alp-quitado-fila';
    const celda = document.createElement('td');
    celda.colSpan = 5;
    celda.appendChild(caja);
    envoltura.appendChild(celda);
    const sig = dato.siguiente && cuerpo.querySelector('tr[data-key="' + CSS.escape(dato.siguiente) + '"]');
    cuerpo.insertBefore(envoltura, sig || null);
  } else if (cont) {
    cont.appendChild(caja);
  } else return;
  avisoQuitar = envoltura;
  anunciar('Quitaste ' + dato.nombre + ' del carrito. Puedes deshacerlo.');
  /* Se va sola a los 6 segundos, pero no mientras el cursor o el foco están encima. */
  let vista = false;
  const seguir = () => {
    if (avisoQuitar !== envoltura || !vista || document.hidden) return;
    clearTimeout(relojQuitar);
    relojQuitar = setTimeout(() => cerrarDeshacer(true), 6000);
  };
  reanudarQuitar = seguir;
  caja.addEventListener('mouseenter', () => clearTimeout(relojQuitar));
  caja.addEventListener('mouseleave', () => { if (!caja.contains(document.activeElement)) seguir(); });
  caja.addEventListener('focusin', () => { if (usoTeclado) clearTimeout(relojQuitar); });
  caja.addEventListener('focusout', (e) => { if (!caja.contains(e.relatedTarget)) seguir(); });
  const activo = document.activeElement;
  if (!activo || activo === document.body || !activo.isConnected || activo.closest('.removing')) darFoco(b, false);
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => {
      if (avisoQuitar !== envoltura) { io.disconnect(); return; }
      if (es.some((e) => e.isIntersecting)) { io.disconnect(); ioQuitar = null; vista = true; seguir(); }
    }, { threshold: 0.5 });
    io.observe(caja);
    ioQuitar = io;
  } else { vista = true; seguir(); }
}

/* Se guarda qué se quitó en el momento del aviso de Horizon (la fila todavía está en pantalla). */
function datoDeLinea(clave) {
  const caja = document.querySelector('[data-alp-cr][data-key="' + CSS.escape(clave) + '"]');
  if (!caja) return null;
  return {
    clave,
    variante: Number(caja.getAttribute('data-variante')),
    cantidad: Number(caja.getAttribute('data-cantidad')) || 1,
    nombre: caja.getAttribute('data-nombre') || 'la prenda',
    props: leerProps(caja.getAttribute('data-props')),
    enCajon: !!caja.closest('#cart-drawer'),
    siguiente: (() => { const f = caja.closest('tr'); const s = f && f.nextElementSibling; return s ? s.getAttribute('data-key') : null; })(),
  };
}

/* ── "Agregaste …" arriba del cajón cuando se abre tras agregar desde la ficha ── */
function marcarAgregado(lineas) {
  const id = lineas && lineas[0] && Number(String(lineas[0].merchandiseId || lineas[0].id || '').replace(/\D/g, ''));
  if (!id) return;
  const caja = document.querySelector('#cart-drawer [data-alp-cr][data-variante="' + id + '"]');
  const titulo = document.querySelector('#cart-drawer .theme-drawer__header');
  if (!caja || !titulo) return;
  cerrarDeshacer();
  let p = document.querySelector('#cart-drawer .alp-agregaste');
  if (!p) {
    p = document.createElement('p');
    p.className = 'alp-agregaste';
    titulo.appendChild(p);
  }
  p.textContent = 'Agregaste ' + caja.getAttribute('data-nombre') + ' ✓';
  const fila = caja.closest('tr');
  if (fila) {
    mostrarEn(fila);
    fila.classList.remove('alp-nueva');
    void fila.offsetWidth;
    fila.classList.add('alp-nueva');
  }
}

/* ── Eventos ── */
document.addEventListener('click', (ev) => {
  const t = ev.target instanceof Element ? ev.target : null;
  if (!t) return;

  const editar = t.closest('[data-alp-cr-editar]');
  if (editar) {
    ev.preventDefault();
    abrirRegalo(editar.closest('[data-alp-cr]'), editar.getAttribute('aria-expanded') !== 'true');
    return;
  }
  const cancelar = t.closest('[data-alp-cr-cancelar]');
  if (cancelar) { ev.preventDefault(); abrirRegalo(cancelar.closest('[data-alp-cr]'), false); return; }
  const guardar = t.closest('[data-alp-cr-guardar]');
  if (guardar) { ev.preventDefault(); guardarRegalo(guardar.closest('[data-alp-cr]'), false); return; }
  const quitarR = t.closest('[data-alp-cr-quitar]');
  if (quitarR) { ev.preventDefault(); guardarRegalo(quitarR.closest('[data-alp-cr]'), true); return; }

  const sumarB = t.closest('[data-alp-sumar]');
  if (sumarB) { ev.preventDefault(); sumar(sumarB); return; }

  const cambiar = t.closest('[data-alp-ce-cambiar]');
  if (cambiar) {
    ev.preventDefault();
    const caja = cambiar.closest('[data-alp-entrega]');
    const form = caja.querySelector('[data-alp-ce-form]');
    const abrir = form.hidden;
    form.hidden = !abrir;
    cambiar.setAttribute('aria-expanded', String(abrir));
    if (abrir) {
      const i = form.querySelector('input');
      try { i.value = localStorage.getItem(CLAVE_CIUDAD) || ''; } catch (e) {}
      i.focus();
    }
  }
});

/* Escape dentro de la tarjeta cierra solo la tarjeta (no todo el carrito), sin perder lo guardado. */
document.addEventListener('keydown', (ev) => {
  if (ev.key !== 'Escape') return;
  const t = ev.target instanceof Element ? ev.target : null;
  const caja = t && t.closest('[data-alp-cr][data-editando]');
  if (caja) { ev.preventDefault(); ev.stopPropagation(); abrirRegalo(caja, false); return; }
  const form = t && t.closest('[data-alp-ce-form]');
  if (form && !form.hidden) {
    ev.preventDefault(); ev.stopPropagation();
    form.hidden = true;
    const b = form.closest('[data-alp-entrega]').querySelector('[data-alp-ce-cambiar]');
    if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
  }
}, true);

document.addEventListener('input', (ev) => {
  const t = ev.target;
  const caja = t instanceof HTMLTextAreaElement ? t.closest('[data-alp-cr]') : null;
  if (caja) { contar(t); borradores.set(caja.getAttribute('data-key'), t.value); }
});

document.addEventListener('submit', (ev) => {
  const form = ev.target instanceof Element ? ev.target.closest('[data-alp-ce-form]') : null;
  if (!form) return;
  ev.preventDefault();
  const i = form.querySelector('input');
  let v = (i.value || '').trim().slice(0, 40);
  const l = v ? buscar(v) : null;
  if (l) v = l.nombre.slice(0, 40);
  try { if (v) localStorage.setItem(CLAVE_CIUDAD, v); else localStorage.removeItem(CLAVE_CIUDAD); } catch (e) {}
  form.hidden = true;
  const caja = form.closest('[data-alp-entrega]');
  const boton = caja && caja.querySelector('[data-alp-ce-cambiar]');
  if (boton) { boton.setAttribute('aria-expanded', 'false'); if (usoTeclado || form.contains(document.activeElement) || focoPerdido()) darFoco(boton, usoTeclado); }
  pintar();
  anunciar(v ? 'Envío calculado para ' + v + '. Total: ' + ultimoTotal + '.' : 'Ciudad borrada. Total: ' + ultimoTotal + '.');
}, true);

/* Ir a pagar con una tarjeta a medio escribir o guardándose: primero se termina de guardar, después se paga. */
let pagando = false;
/* La ciudad que la persona ya eligió viaja al pago: así Shipfn muestra desde el inicio la tarifa de Quito ($4.99) y Flash.
   Va solo si la ciudad es conocida (de la lista de lugares, o Quito y valles); si no, el pago abre como siempre. */
function urlPago() {
  let c = '';
  try { c = localStorage.getItem(CLAVE_CIUDAD) || ''; } catch (e) {}
  const l = c ? buscar(c) : null;
  if (!l || !(l.tipo === 'quito' || LUGARES.some((L) => L[0] === l.nombre))) return '';
  return raiz + 'checkout?' + new URLSearchParams({ 'checkout[shipping_address][city]': l.nombre, 'checkout[shipping_address][country]': 'Ecuador' }).toString();
}
document.addEventListener('submit', async (ev) => {
  const form = ev.target;
  if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form' || pagando) return;
  const boton = ev.submitter;
  if (!boton || boton.name !== 'checkout') return;
  const borrador = regaloSinGuardar();
  if (!trabajando && !borrador) { const u = urlPago(); if (u) { ev.preventDefault(); location.href = u; } return; }
  ev.preventDefault();
  pagando = true;
  boton.setAttribute('aria-busy', 'true');
  let seguir = true;
  try {
    if (borrador) seguir = await Promise.race([guardarRegalo(borrador, false), new Promise((r) => setTimeout(() => r(false), 8000))]);
    await Promise.race([cola, new Promise((r) => setTimeout(r, 8000))]);
  } catch (e) { seguir = false; }
  boton.removeAttribute('aria-busy');
  if (!seguir && borrador) {
    const t = borrador.querySelector('textarea');
    if (t) { mostrarEn(t); t.focus({ preventScroll: true }); }
  }
  if (seguir) {
    const f = form.isConnected ? form : document.getElementById('cart-form');
    const b = boton.isConnected ? boton : (f && f.querySelector('[name="checkout"]'));
    const u = urlPago();
    if (u) location.href = u; else if (f && b) f.requestSubmit(b); else if (f) f.submit();
  }
  setTimeout(() => { pagando = false; }, 1500);
}, true);

/* Horizon vuelve a dibujar el carrito después de cada cambio: se repinta encima. */
let pendiente = 0;
const DEL_CARRITO = '#cart-drawer, cart-items-component, [data-alp-totales], [data-alp-entrega], [data-alp-mini]';
const observador = new MutationObserver((lista) => {
  if (pendiente) return;
  for (const m of lista) {
    const t = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (t && t.closest && t.closest(DEL_CARRITO)) {
      pendiente = requestAnimationFrame(() => { pendiente = 0; pintar(); });
      return;
    }
  }
});
/* Solo se miran las secciones que tienen carrito (no toda la página). */
const vistas = new WeakSet();
function vigilarSecciones() {
  document.querySelectorAll('.shopify-section').forEach((s) => {
    if (vistas.has(s) || !s.querySelector(DEL_CARRITO)) return;
    vistas.add(s);
    observador.observe(s, { childList: true, subtree: true, characterData: true });
  });
  const cajon = document.getElementById('cart-drawer');
  if (cajon && !vistas.has(cajon)) { vistas.add(cajon); observador.observe(cajon, { childList: true, subtree: true, characterData: true }); }
}
let cajonVigilado = null;
function vigilarCajon() {
  const dlg = document.querySelector('#cart-drawer dialog');
  if (!dlg || dlg === cajonVigilado) return;
  cajonVigilado = dlg;
  const marcar = () => { const html = document.documentElement; if (html.classList.contains('alp-cajon-abierto') !== dlg.open) html.classList.toggle('alp-cajon-abierto', dlg.open); };
  new MutationObserver(marcar).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  marcar();
}
function vigilar() {
  pintar();
  vigilarSecciones();
  vigilarCajon();
}
document.addEventListener('shopify:cart:lines-update', (ev) => {
  const propio = ev.target instanceof Element && ev.target.closest && ev.target.closest('[data-alp-sumar], .alp-quitado');
  const quitado = ev.action === 'remove' && ev.lines && ev.lines[0] && ev.lines[0].id ? datoDeLinea(String(ev.lines[0].id)) : null;
  if (!ev.promise || !ev.promise.then) return;
  ev.promise.then((res) => {
    setTimeout(() => {
      pintar();
      vigilarSecciones();
      if (res && res.detail && res.detail.didError) return;
      if (quitado) { marcarQuitado(quitado.variante, true); mostrarDeshacer(quitado, quitado.enCajon && !!document.querySelector('#cart-drawer dialog[open]')); }
      if (ev.action === 'remove') revisarSumados();
      if (codigosAplicados && codigosAplicados.length) releerCodigos();
      if (ev.action === 'add' && !propio && !(res && res.detail && res.detail.source === 'alpaca-carrito')) marcarAgregado(ev.lines);
    }, 120);
  }, () => {});
});
document.addEventListener('theme-drawer:close', (e) => {
  if (!(e.target instanceof Element) || e.target.id !== 'cart-drawer') return;
  const p = document.querySelector('#cart-drawer .alp-agregaste');
  if (p) p.remove();
  cerrarDeshacer();
});
/* Al poner o quitar un código de descuento: se guardan los códigos aplicados y se repinta el resumen. */
document.addEventListener('shopify:cart:discount-update', (ev) => {
  if (!ev.promise || !ev.promise.then) return;
  ev.promise.then((res) => {
    const lista = res && res.cart && res.cart.discountCodes;
    if (Array.isArray(lista)) guardarCodigos(lista);
    else { releerCodigos(); return; }
    setTimeout(() => { pintar(); vigilarSecciones(); }, 120);
  }, () => {});
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilar);
else vigilar();
/* Si ya hay un resumen en la página, se leen los códigos guardados en el carrito (una sola vez). */
if (document.querySelector('[data-alp-totales]')) releerCodigos();
else document.addEventListener('DOMContentLoaded', () => { if (document.querySelector('[data-alp-totales]')) releerCodigos(); }, { once: true });
window.addEventListener('storage', (e) => { if (e.key === CLAVE_CIUDAD) pintar(); });
setInterval(() => { if (!document.hidden) pintar(); }, 60000);

/* ── Una caja por prenda (atributo del carrito) y «x» de la sugerencia (11/10/2026) ── */
const CLAVE_SIN_SUG = 'alpaca_sin_sugerencia';
try { if (sessionStorage.getItem(CLAVE_SIN_SUG)) document.documentElement.setAttribute('data-alp-sin-sug', ''); } catch (e) {}
document.addEventListener('click', (e) => {
  const x = e.target.closest && e.target.closest('[data-alp-cs-cerrar]');
  if (!x) return;
  e.preventDefault();
  document.documentElement.setAttribute('data-alp-sin-sug', '');
  try { sessionStorage.setItem(CLAVE_SIN_SUG, '1'); } catch (er) {}
});
document.addEventListener('change', (e) => {
  const c = e.target.closest && e.target.closest('[data-alp-cajas]');
  if (!c) return;
  const marcada = c.checked;
  document.querySelectorAll('[data-alp-cajas]').forEach((o) => { o.checked = marcada; o.disabled = true; });
  fetch(raiz + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { 'Una caja por prenda': marcada ? 'Sí' : 'No' } }),
  })
    .then((r) => { if (!r.ok) throw new Error(String(r.status)); })
    .catch(() => { document.querySelectorAll('[data-alp-cajas]').forEach((o) => { o.checked = !marcada; }); })
    .finally(() => { document.querySelectorAll('[data-alp-cajas]').forEach((o) => { o.disabled = false; }); });
});
